/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Title_FallbackInputs */



/**
* | output |
* | --- |
* | "Help" |
*
* @param {Help_Title_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_title_fallback = /** @type {((inputs?: Help_Title_FallbackInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Title_FallbackInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayuda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ajuda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aiuto")
	return /** @type {LocalizedString} */ ("Help")
});